
import barba from '@barba/core';
import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){
        this.heroContent = document.querySelector("#l-hero__wrapper")
        this.heroContentWrapper = document.querySelector("#l-hero__content")
        if(this.heroContent){
            let winH = window.innerHeight
            let timeoutId
            let is_scroll = false
            this.heroContent.style.height = winH + "px"
            this.heroContentWrapper.style.height = winH + "px"
            window.addEventListener("resize", () => {
                if( is_scroll ){
                    return false
                }
                let winH = window.innerHeight
                this.heroContent.style.height = winH + "px"
                this.heroContentWrapper.style.height = winH + "px"
                
            })
            window.addEventListener("scroll", () => {
                is_scroll = true
                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000 ) ;
            })            
            window.addEventListener("touchmove", () => {
                if( !is_scroll ){
                    is_scroll = true
                }
            })
            window.addEventListener("touchend", () => {

                clearTimeout( timeoutId ) ;
                timeoutId = setTimeout(() => {
                    if( is_scroll ){
                        is_scroll = false
                    }
                }, 1000 ) ;
                
            })
        }

        const heroWrapper = document.querySelector("#l-hero__wrapper")
        if(heroWrapper){
            setTimeout(function(){
                let heroAnimation =  anime.timeline();
                heroAnimation.add({
                    targets : '.l-hero__image',
                    scale: [1.1,1],
                    translateY: ["10%",0],
                    opacity:[0,1],
                    easing: "easeOutQuart",
                    duration:1000
                })
                .add({
                    targets : '.l-hero__catch',
                    translateY: ["10%",0],
                    opacity:[0,1],
                    easing: "easeOutQuart",
                    duration:2000
                },"-=400")
            },1600)
        }
    }
}